import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentSchemaRenderProps, RenderComponent } from "~/components/schema-render/content";
import type { blockquoteLongReadContent$key } from "~/queries/__generated__/blockquoteLongReadContent.graphql";

import { Author, Blockquote, Container, StyledContentShareWidget } from "./styles";

type Props = {
  reference?: blockquoteLongReadContent$key;
} & ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ reference: reference_, schemaNode }) => {
  const content = useFragment(
    graphql`
      fragment blockquoteLongReadContent on Content {
        ...contentShareWidgetContent
      }
    `,
    reference_ ?? null,
  );
  if (!content) return null;

  const [quoteNode, sourceNode] = schemaNode.children ?? [];

  return (
    <Container>
      <Blockquote>
        {quoteNode?.data}
        <Author>{sourceNode?.data}</Author>
      </Blockquote>
      <StyledContentShareWidget
        customGATracking={{
          category: "Share button (block quote)",
        }}
        position="block_quote"
        reference={content}
        style={{ backgroundColor: "transparent", color: "#001246" }}
        types={["facebook", "twitter", "email"]}
      />
    </Container>
  );
};

Component.displayName = "BlockquoteLongRead";

export const BlockquoteLongRead: RenderComponent<Props> = styled(Component)``;
BlockquoteLongRead.isHandlingOwnChildren = true;
